import React from 'react';
import { TemplateComponent } from '@zonofi/zono-money-store';
import './template-header.scss';

interface TemplateHeaderProps {
  header: TemplateComponent;
}

export const TemplateHeader: React.FC<TemplateHeaderProps> = ({ header }) => {
  if (!header) return null;

  switch (header.format) {
    case 'TEXT':
      return (
        <div className="template-header template-header--text font-regular">
          {header.text}
        </div>
      );

    case 'IMAGE': {
      const imageUrl = header?.example?.header_handle?.[0];
      if (!imageUrl) return null;

      return (
        <div className="template-header template-header--image">
          <img src={imageUrl} alt="header" />
        </div>
      );
    }
    default:
      return null;
  }
};
